export const zoomHours = (timeframe: string) => timeframe === '4h' ? [168, 96, 48, 24]
  : timeframe === '1h' ? [48, 24, 12, 6] : [12, 6, 2, 0.5];

export function timelineWindow(end: number, fullStart: number, timeframe: string, zoom: number) {
  const hours = zoomHours(timeframe);
  const bounded = Math.max(0, Math.min(hours.length, zoom));
  const start = bounded === 0 ? fullStart : Math.max(fullStart, end - hours[bounded - 1] * 3_600_000);
  return { start, end, zoom: bounded, canZoomOut: bounded > 0, canZoomIn: bounded < hours.length,
    label: bounded === 0 ? 'Full' : hours[bounded - 1] < 1 ? `${hours[bounded - 1] * 60}m` : `${hours[bounded - 1]}h` };
}
